// Tâche 1457 (Eric 2026-06) — Accepter d'un coup toutes les fautes d'UNE
// catégorie.
//
// > « Ajoute 1 bouton général pour accepter toutes les modifications
// >   détectées pour cette catégorie, placé à droite du bouton "Détecter ces
// >   fautes dans toute la base", avec une alerte / confirmation en rouge
// >   quand il est pressé. »
//
// Portée CHOISIE par Eric : **un type de connaissance à la fois**, choisi dans
// le menu à côté du bouton (et non « tout le balayage »). Une acceptation
// massive sans bornes serait impossible à relire.
//
// ⚠️ La confirmation est ROUGE et dit le NOMBRE exact : « tout accepter » est
// la seule action de cet écran qui écrit dans des centaines de documents d'un
// coup. Chaque correction reste annulable une par une (même journal), mais
// encore faut-il savoir ce qu'on vient de déclencher.
import { useState } from "react";
import { Lightning, SpinnerGap } from "@phosphor-icons/react";
import { confirmDialog } from "../../lib/uiDialogs";
import { useLang } from "../../contexts/LanguageContext";

export const AccepterCategorie = ({ comptes, libellesZone, onAccepter }) => {
  const { lang, tr } = useLang();
  const [zone, setZone] = useState("");
  const [enCours, setEnCours] = useState(false);

  const zones = Object.keys(comptes || {}).filter((z) => comptes[z] > 0);
  if (!zones.length) return null;

  const etiquette = (z) => {
    const paire = libellesZone?.[z];
    if (!paire) return z;
    return lang === "en" ? paire[1] : paire[0];
  };

  const lancer = async () => {
    if (!zone) return;
    const nb = comptes[zone] || 0;
    const ok = await confirmDialog(
      tr(`Accepter les ${nb} correction(s) détectée(s) dans « ${etiquette(zone)} » ?\n\nLe texte de ${nb} endroit(s) sera réécrit immédiatement. Chaque correction reste annulable une par une depuis le journal.`,
         `Accept the ${nb} fix(es) detected in "${etiquette(zone)}"?\n\nThe text of ${nb} place(s) will be rewritten immediately. Each fix stays undoable one by one from the log.`),
      {
        tone: "destructive",
        confirmLabel: tr(`Oui, corriger les ${nb} endroits`, `Yes, fix the ${nb} places`),
        cancelLabel: tr("Annuler", "Cancel"),
      });
    if (!ok) return;
    setEnCours(true);
    try {
      await onAccepter(zone);
    } finally {
      setEnCours(false);
    }
  };

  return (
    <div className="flex items-center gap-1.5" data-testid="orthographe-accepter-categorie">
      <select
        value={zone}
        onChange={(e) => setZone(e.target.value)}
        className="px-2 py-2 border border-zinc-300 rounded-md text-xs bg-white focus:outline-none focus:ring-1 focus:ring-[#002FA7]"
        data-testid="orthographe-accepter-categorie-choix"
      >
        <option value="">{tr("Choisir une catégorie…", "Pick a category…")}</option>
        {zones.map((z) => (
          <option key={z} value={z}>
            {etiquette(z)} ({comptes[z]})
          </option>
        ))}
      </select>
      <button
        type="button"
        onClick={lancer}
        disabled={!zone || enCours}
        className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md bg-rose-600 text-white text-xs font-medium hover:bg-rose-700 transition-colors disabled:opacity-40"
        data-testid="orthographe-accepter-categorie-bouton"
      >
        {enCours
          ? <SpinnerGap size={14} className="animate-spin" />
          : <Lightning size={14} weight="fill" />}
        {tr("Tout accepter dans cette catégorie", "Accept everything in this category")}
      </button>
    </div>
  );
};

export default AccepterCategorie;
